<template>
<div class="user-deals">

  <page-header>
    <nav-inner :use-user-links="true"/>
  </page-header>
  <router-link
    class="help-link help-link_pcr"
    :to="{ path: '/help/24'}"
    target="_blank">
      Подробнее о моих сделках в разделе Помощь
  </router-link>

  <div class="page-container">
    <div class="block-wrap block-wrap_btns">
      <button
        @click="setDealsMode('myObjects')"
        :class="getDealBtnClass('myObjects')">
        Объекты других пользователей</button>
      <button
        @click="setDealsMode('foreignObjects')"
        :class="getDealBtnClass('foreignObjects')">
        Мои объекты</button>
    </div>
    <template v-if="deals && deals.length !== 0 && !loading">
    <object-deal
      v-for="(deal, i) in deals"
      :key="`object-deal-${i}`"
      :dataSource="deal"
      :dealsMode="dealsMode"/>
    <el-pagination
      v-show="paginationVisible"
      :page-size="limit"
      :total="found"
      :current-page="currentPage"
      @current-change="currentChange"
      layout="prev, pager, next, jumper"/>
    </template>
    <template v-else-if="!loading">
      <div class="empty-deals">
        <template v-if="dealsMode === 'myObjects'">
          На текущий момент Вами не заключено ни одной сделки
        </template>
        <template v-else-if="dealsMode === 'foreignObjects'">
          На текущий момент с Вашими объектами не заключено ни одной сделки
        </template>
      </div>
    </template>
  </div>

  <page-footer/>

</div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import ObjectDeal from '../ObjectDeal';
import Misc from '../../mixins/Misc';

export default {

  mixins: [Misc],

  components: { PageHeader, PageFooter, NavInner, ObjectDeal },

  data() {
    return {
      dealsMode: 'myObjects',
      deals: [],
      paginationVisible: false,
      limit: 20,
      found: 1,
      offset: 0,
      currentPage: 1,
      loading: false,
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {

    getDealBtnClass(btnMode) {
      let btnClass = 'select-deals-type';
      if (btnMode === this.dealsMode) btnClass = `${btnClass} selected-deal-type`;
      return btnClass;
    },

    setDealsMode(mode) {
      this.dealsMode = mode;
      this.$router.push({ path: this.$route.path });
      this.fetchData();
    },

    fetchData() {
      this.loading = true;
      let request = 'deals/my';
      if (this.dealsMode === 'foreignObjects') request = `${request}/objects`;
      const query = {};
      if (this.$route.query.offset) query.offset = this.$route.query.offset;
      axios.get(request, { params: query }).then((response) => {
        this.offset = typeof this.$route.query.offset !== 'undefined' ? this.$route.query.offset : 0;
        this.found = response.data.Found;
        this.paginationVisible = Math.floor((this.found - 1) / this.limit) > 0;
        this.currentPage = Math.floor(this.offset / this.limit) + 1;
        this.$nextTick(() => {
          this.deals = response.data.Deals;
        });
      })
        .finally(() => {
          this.loading = false;
        });
    },

    currentChange(curPage) {
      const query = Object.assign({}, this.$route.query);
      query.offset = this.limit * (curPage - 1);
      this.$router.push({ path: this.$route.path, query });
      this.scrollTop();
    },

  },
};
</script>

<style lang="scss" scoped>
.page-container {
  max-width: 1250px;
  width: 100%;
  padding: 0 25px;
  margin: 0 auto;
}
.select-deals-type {
  background: none;
  border: none;
  padding: 12px 35px 9px;
  color: #aaa;
  text-transform: uppercase;
  font-size: 13px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  border-radius: 3.5em;
  border: 1px solid #aaa;
  overflow: hidden;
  &:hover {
    color: #ccc;
    background-color: rgba(170, 170, 170, 0.1);
  }
}
.selected-deal-type {
  color:#000;
  font-weight: bold;
  &:hover {
    color:#000;
  }
}
.empty-deals {
  text-align: center;
}
.theme-b {
  .select-deals-type {
    color:#aaa;
    border-color: #aaa;
    &:hover {
      color: #aaa;
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  .selected-deal-type {
    color:#fff;
    &:hover {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  .empty-deals {
    color:#fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserDeals.vue